<template>
    <div class="container">
        <div class="about-banner">
            <img src="../../assets/images/fx1.jpg" />
            <p class="title">{{ t('sharec.bannertitle') }}</p>
        </div>
        <div class="navigation-bar">
            <div class="navigation-bar-txt">
                <span><router-link to="/">{{ t('menu.home') }}</router-link></span>
                <span>{{ t('menu.sharingcenter') }}</span>
            </div>
        </div>
        <div class="new-list-bar">
            <div class="news-list">
                <div class="left-list">
                    <h3>{{ t('sharec.moduleA.title') }}</h3>
                    <p class="subtitle">Q：{{ t('sharec.moduleA.q') }}</p>
                    <p class="content">A：{{ t('sharec.moduleA.a') }}</p>
                    <p class="subtitle">Q：{{ t('sharec.moduleA.q1') }}</p>
                    <p class="content">A：{{ t('sharec.moduleA.a1') }}</p>
                </div>
                <div class="right-list">
                    <img class="fr" src="../../assets/images/fx2.jpg" />
                </div>
            </div>
        </div>
        <div class="new-list-bar">
            <div class="news-list">
                <div class="right-list">
                    <img class="fl" src="../../assets/images/fx3.jpg" />
                </div>
                <div class="left-list">
                    <h3>{{ t('sharec.moduleB.title') }}</h3>
                    <p class="subtitle">Q：{{ t('sharec.moduleB.q') }}</p>
                    <p class="content">A：{{ t('sharec.moduleB.a') }}</p>
                    <ul class="ul-list">
                        <li v-for="item in t('sharec.moduleB.list').split(';')" :key="item">
                            <i class="li-icon"></i><span class="span-txt">{{ item }}</span>
                        </li>
                    </ul>
                    <p class="subtitle">Q：{{ t('sharec.moduleB.q1') }}</p>
                    <p class="content">A：{{ t('sharec.moduleB.a1') }}</p>
                   
                </div>
            </div>
        </div>
        <div class="new-list-bar">
            <div class="news-list">
                <div class="left-list">
                    <div class="left-list">
                        <h3>{{ t('sharec.moduleC.title') }}</h3>
                        <p class="subtitle">Q：{{ t('sharec.moduleC.q') }}</p>
                        <p class="content">A：{{ t('sharec.moduleC.a') }}</p>
                    </div>
                </div>
                <div class="right-list">
                    <img class="fr" src="../../assets/images/fx4.jpg" />
                </div>
            </div>
        </div>
        <div class="new-list-bar">
            <div class="news-list">
                <div class="right-list">
                    <img class="fl" src="../../assets/images/fx5.jpg" />
                </div>
                <div class="left-list">
                    <h3>{{ t('sharec.moduleD.title') }}</h3>
                    <p class="subtitle">Q：{{ t('sharec.moduleD.q') }}</p>
                    <p class="content">A：{{ t('sharec.moduleD.a') }}</p>
                </div>
            </div>
        </div>
        <div class="new-list-bar">
            <div class="news-list">
                <div class="left-list">
                    <h3>{{ t('sharec.moduleE.title') }}</h3>
                    <p class="content">A：{{ t('sharec.moduleE.q') }}</p>
                    <ul class="ul-list">
                        <li v-for="item in t('sharec.moduleE.a').split(';')" :key="item">
                            <i class="li-icon"></i><span class="span-txt">{{ item }}</span>
                        </li>
                    </ul>
                </div>
                <div class="right-list">
                    <img class="fr" src="../../assets/images/fx6.jpg" />
                </div>
            </div>
        </div>
        <div class="new-list-bar">
            <h3 class="download-title">{{ t('download.title') }}</h3>
            <ul class="download-list" v-if="locale=='zh'">
                <li>
                    <i class="li-icon"></i><a class="span-txt" href="/files/超重转盘挤奶机.pdf" download="超重转盘挤奶机.pdf"><span class="dec">超重转盘挤奶机.pdf</span><i class="download-icon"></i></a>
                </li>
                <li>
                    <i class="li-icon"></i><a class="span-txt" href="/files/奶衬.pdf" download="奶衬.pdf"><span class="dec">奶衬.pdf</span><i class="download-icon"></i></a>
                </li>
                <li>
                    <i class="li-icon"></i><a class="span-txt" href="/files/全封闭并列式挤奶机.pdf" download="全封闭并列式挤奶机.pdf"><span class="dec">全封闭并列式挤奶机.pdf</span><i class="download-icon"></i></a>
                </li>
                <li>
                    <i class="li-icon"></i><a class="span-txt" href="/files/智慧牧场和挤奶厅规划设计.pdf" download="智慧牧场和挤奶厅规划设计.pdf"><span class="dec">智慧牧场和挤奶厅规划设计.pdf</span><i class="download-icon"></i></a>
                </li>
                <li>
                    <i class="li-icon"></i><a class="span-txt" href="/files/智能分群门.pdf" download="智能分群门.pdf"><span class="dec">智能分群门.pdf</span><i class="download-icon"></i></a>
                </li>
                <li>
                    <i class="li-icon"></i><a class="span-txt" href="/files/待机厅.mp4" download="待机厅.mp4"><span class="dec">待机厅.mp4</span><i class="download-icon"></i></a>
                </li>
            </ul>
            <ul class="download-list" v-else-if="locale=='en'">
                <li>
                    <i class="li-icon"></i><a class="span-txt" href="/files/CIA rotary brochure_20260812170800.pdf" download="CIA rotary brochure_20260812170800.pdf"><span class="dec">CIA rotary brochure_20260812170800.pdf</span><i class="download-icon"></i></a>
                </li>
            </ul>
            <ul class="download-list" v-else>
                <li>
                   暂无
                </li>
            </ul>
        </div>
    </div>
</template>
<script setup>
import { watch } from "vue";
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
watch(locale, (newValue) => {
    if (newValue === 'zh') {
        console.log('当前语言为中文')
    } else if (newValue === 'en') {
        console.log('当前语言为英文')
    }
}, { immediate: true })


</script>
<style lang="scss" scoped>
.new-list-bar {
    padding: 30px;
}

.download-title {
    margin: 0px auto 20px;
    font-size: 32px;
}

.download-list {
    display: flex;
    flex-direction: column;
    margin-top: 6px;

    li {
        display: flex;
        flex-direction: row;
        padding: 2px 0px;

        .li-icon {
            display: block;
            width: 24px;
            height: 24px;
            background: url('../../assets/images/li-icon.svg') no-repeat left 7px;
        }
       
        .span-txt {
            margin-left: 10px;
            display: flex;
            justify-content:space-between;
            flex: 1;
            line-height: 32px;
            font-size: 16px;
            .dec{
             display: block;
             color:#333
            }
            .download-icon {
            display: block;
            width: 24px;
            height: 24px;
            background: url('../../assets/images/download.svg') no-repeat left 7px;
            }
        }
    }
}

.about-banner {
    width: 100%;
    position: relative;

    img {
        display: block;
        width: 100%;
    }

    p {
        width: 800px;
        position: absolute;
        text-align: center;
        left: 50%;
        margin-left: -400px;
        color: #fff;
    }

    .title {
        top: 190px;
        font-size: 40px;
        font-weight: 600;
        letter-spacing: 1px;
    }


}

.news-list {
    justify-items: center;
    justify-content: center;

    .left-list {
        flex: 1.6;
        padding: 10px 20px 30px 20px;

        h3 {
            margin: 0px auto 20px;
            font-size: 32px;
        }

        .subtitle {
            font-size: 18px;
            text-align: left;
            margin-bottom: 10px;
        }

        .content {
            margin-top: 10px;
            font-size: 16px;
            line-height: 32px;
            text-align: left;
        }

        .ul-list {
            display: flex;
            flex-direction: column;
            margin-top: 6px;

            li {
                display: flex;
                flex-direction: row;
                padding: 2px 0px;

                .li-icon {
                    display: block;
                    width: 24px;
                    height: 24px;
                    background: url('../../assets/images/li-icon.svg') no-repeat left 7px;
                }

                .span-txt {
                    margin-left: 10px;
                    flex: 1;
                    display: block;
                    line-height: 32px;
                    font-size: 16px;
                }
            }
        }
    }

    .right-list {
        flex: 1.6;
        border: 4px;
        width: 90%;
        height: 440px;
        overflow: hidden;

        // border: 6px solid #f8f8f8;
        img {
            width: 100%;
            box-sizing: border-box;
        }
    }
}
</style>